import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const uploadFormTemplate = htmlE`
    <style>
      #uploadFormTemplate .file-navigation-upload-form {
        border-bottom: 1px solid var(--border-color);
      }

      #uploadFormTemplate .do-not-show-form-for-add-files-container {
        border-top: 1px solid var(--border-color);
      }

      #uploadFormTemplate .do-not-show-form-for-add-files {
        background-color: var(--accent-color);
        padding: 3px 0.25rem;
      }

      #uploadFormTemplate #uploadFormContainer {
        overflow: auto;
      }

      #uploadFormTemplate .quick-view-btn {
        position: relative;
        background-color: var(--backdrop-color);
        opacity: 0.6;
        padding: 0.5rem;
        height: 2rem;
        width: 2rem;
        border-radius: 50%;
        cursor: pointer;
        border: none;
        transition: opacity 0.2s;
      }

      #uploadFormTemplate .quick-view-btn:hover {
        background-color: var(--accent-background-secondary);
        opacity: 0.8;
      }

      #uploadFormTemplate .quick-view-btn i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.9rem;
        color: var(--text-primary);
      }

      #uploadFormTemplate .quick-view-btn:disabled {
        background-color: rgba(150, 150, 150);
        color: rgba(130, 130, 130);
      }

    </style>

    <div id="uploadFormTemplate" class="is-flex gap-3 is-flex-direction-column h-full">
        <div class="file-navigation-upload-form pb-2 is-flex is-justify-content-space-between is-align-items-center">

            <div class="is-ellipsis is-clipped whitespace-nowrap is-flex-grow-1">
                <span data-i18n-key="forItem">For Item</span> : <span class="has-text-weight-semibold upload-file-name"></span>
            </div>

            <div class="is-flex">
                <button data-tooltip="Prev File" class="quick-view-btn upload-form-prev-btn mr-2" aria-label="forward-btn">
                    <i class="icon-chevron-left"></i>
                </button>
                <button data-tooltip="Next File" class="quick-view-btn upload-form-next-btn" aria-label="backward-btn">
                    <i class="icon-chevron-right"></i>
                </button>
            </div>
        </div>

        <div class="is-flex-grow-1" id="uploadFormContainer"></div>
        ${({
          uploadFormAskAgainHideAndUnchecked,
          uploadFormAskAgainHideAndChecked,
          uploadFormAskAgainChecked,
        }) => {
          return !uploadFormAskAgainHideAndUnchecked &&
            !uploadFormAskAgainHideAndChecked
            ? `<div class="pt-2 do-not-show-form-for-add-files-container is-flex-shrink-1">
            <div class="is-inline do-not-show-form-for-add-files">
                <label class="p-1 text-sm is-cursor-pointer text-secondaryMain" for="doNotShowAddFilesCheck">
                    <input
                      ${uploadFormAskAgainChecked ? "checked" : ""}
                      id="doNotShowAddFilesCheck" class="is-cursor-pointer" type="checkbox">
                    <span class="ml-1"  data-i18n-key="dontShowFormForAdditionalFiles">Don't show form for additional files</span>
                </label>
            </div>
        </div>`
            : "";
        }}
    </div>`;
